import { useAuth } from '../utils/AuthContext.js';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';

const EmailUpdateHandler = () => {
  const { lang } = useLanguage(translations);
  const { userEmail } = useAuth();

  return (
    <>
      <h1>{lang('emailUpdatedTitle')}</h1>
      <p>{lang('emailUpdatedMessage')}</p>
      <p>
        <b>{userEmail()}</b>
      </p>
    </>
  );
};

export default EmailUpdateHandler;
